import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Helper/Icon'; // This should be a default import
import classnames from 'classnames';

/**
 * This button opens and closes the sidemenu. It's used for the main menu.
 */
const PanelToggleButton = (props) => {
    const { onClick, className, icon, label, 'aria-label': ariaLabel, ...rest } = props;
    const classNames = classnames('panel-toggle-button', props.className);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClick();
        }
    };

    return (
        <div
            role="button"
            tabIndex="0"
            className={classNames}
            onClick={onClick}
            onKeyDown={handleKeyDown}
            aria-label={ariaLabel}
            {...rest}
        >
            {props.icon ? <Icon name={props.icon} isCollapsed={true} /> : null}
            <span className="panel-toggle-button__label">
                {props.label}
            </span>
        </div>
    );
};

PanelToggleButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    label: PropTypes.node,
    icon: PropTypes.string,
    className: PropTypes.string,
    'aria-label': PropTypes.string // A descriptive 
};

export default PanelToggleButton;